import { gql } from '@apollo/client';
import useMutation from 'api/hooks/useMutation';
import permissions from 'api/Apollo/permissions';

import { PLAYBOOK_SECRET_CLUSTERS_QUERY } from './useQueryPlaybookSecretClusters';

export const mutation = gql`
  mutation InsertPlaybookSecretCluster($playbookId: uuid!, $clusterId: uuid!) {
    playbookSecretCluster: insert_playbook_secret_clusters_one(
      object: { playbookId: $playbookId, clusterId: $clusterId }
      on_conflict: { constraint: playbook_secret_clusters_pkey, update_columns: [] }
    ) {
      playbookId
      clusterId
      createdAt
    }
  }
`;

export default function useInsertPlaybookSecretCluster(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    context: { permission: permissions.updateIntegration },
    refetchQueries: [PLAYBOOK_SECRET_CLUSTERS_QUERY],
    ...options,
  });

  const insertPlaybookSecretCluster = ({ playbookId, clusterId }) => {
    return executeMutation({
      variables: { playbookId, clusterId },
    });
  };

  return [insertPlaybookSecretCluster, response];
}
